import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"

const Location = ({ blok }) => {
  // console.log(blok);
  // TODO: Add Google Maps API key, Custom Map, and Custom Marker
  
  return (
    <div {...storyblokEditable(blok)} className="mb-8 flex flex-col items-center" dangerouslySetInnerHTML={{__html: blok.embedMap}} />
  )
}

export default Location
